/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type NotificationsContainer_settings = {
    readonly " $fragmentRefs": FragmentRefs<"UserBoxContainer_settings">;
    readonly " $refType": "NotificationsContainer_settings";
};
export type NotificationsContainer_settings$data = NotificationsContainer_settings;
export type NotificationsContainer_settings$key = {
    readonly " $data"?: NotificationsContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"NotificationsContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationsContainer_settings",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserBoxContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '9babadeec3b86714ad3890960888c5cd';
export default node;
